import { useLocation } from '@app/router';

/**
 * A number of pages such as terms of service, privacy policy, etc are presented as webviews
 * in our native mobile apps. In order to identify traffic we place a ?source=mobile query
 * param onto every url. This allows us to hide our header/footer/etc for these urls.
 */
const useIsMobileAppView = (): boolean => {
  const { search } = useLocation();
  return search.includes('source=mobile');
};

export default useIsMobileAppView;
